import type { EvalWorkflowType } from '@root/domain/schemas/evals/eval-config.schema';
import type {
  EvalCheckResult,
  EvalCheckVerdict,
  EvalFindingGrade,
  EvalFindingResolution,
  EvalFindingSeverity,
  EvalResolutionVerdict,
  EvalRunStatus,
  EvalStepStatus,
} from '@root/domain/schemas/evals/eval-run.schema';

export type {
  EvalCheckResult,
  EvalCheckVerdict,
  EvalFindingGrade,
  EvalFindingResolution,
  EvalFindingSeverity,
  EvalResolutionVerdict,
  EvalRunStatus,
  EvalStepStatus,
  EvalWorkflowType,
};

export type EvalConfigOption = {
  id: string;
  name: string;
  workflow_type: EvalWorkflowType;
  /**
   * Only configs that have at least one published version can be used to
   * start a run — the start handler throws otherwise. We surface this
   * explicitly so the "Run evaluation" button can disable the option.
   */
  current_version_number?: number;
  /**
   * The champion config — the only one whose runs brokers are served. Drives
   * the picker's " · champion" suffix and the broker preview's run filter.
   */
  is_champion?: boolean;
};

export type GradeOption = {
  value: EvalFindingGrade;
  label: string;
  /** Segment label — the drawer is ~340px, so four grades only fit abbreviated. */
  shortLabel: string;
};

export const GRADE_OPTIONS: GradeOption[] = [
  { value: 'TRUE_POSITIVE', label: 'True positive', shortLabel: 'TP' },
  { value: 'FALSE_POSITIVE', label: 'False positive', shortLabel: 'FP' },
  { value: 'PARTIAL', label: 'Partial', shortLabel: 'Partial' },
  { value: 'NEEDS_REVIEW', label: 'Needs review', shortLabel: 'Review' },
];

export const SEVERITY_ORDER: Record<EvalFindingSeverity, number> = {
  HIGH: 0,
  MEDIUM: 1,
  LOW: 2,
  INFO: 3,
};

/** Eval run statuses that still change over time and require polling. */
export const RUN_IS_TERMINAL: Record<EvalRunStatus, boolean> = {
  PENDING: false,
  RUNNING: false,
  SUCCEEDED: true,
  FAILED: true,
  CANCELLED: true,
};
